/*
 * View for selecting a snippet, including a nav tree and a selectable list for showing the snippets in a folder
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/shared/snippetSearch/template/snippetSearchTemplate.html",
  "modules/typeahead/typeaheadModel",
], function (Marionette, Messenger, SnippetSearchTemplate) {
  const SnippetSearchView = {};

  SnippetSearchView.snippetSearchLayout = Marionette.Layout.extend({
    template: SnippetSearchTemplate,
    modelEvents: {
      change: "render",
    },
    regions: {
      snippetTree: "#navTree",
      snippetList: "#navList",
    },
    onRender: function () {
      this.$el.i18n();

      // Ensure the input exists before initializing typeahead
      const input = this.$el.find("input");
      if (!input.length) {
        console.warn("Input element not found for typeahead initialization.");
        return;
      }

      let results;
      //set up source function to get the typeahead data
      const sourceFunction = (query, process) => {
        results = Messenger.reqres.request("snippets:typeahead", {
          blockId: this.model.snippetIdToBlock,
          query,
          languageId: this.model.languageId,
          touchpointId: this.model.touchpointId,
        });
        results
          .onSyncedPromise()
          .then(() => {
            const resultsArray = results.map((model) => model.get("text"));
            process(resultsArray);
          })
          .catch((error) => {
            console.error("Error fetching typeahead results:", error);
            process([]); // Clear results on error
          });
      };

      input.typeahead({
        source: sourceFunction,
        updater: (item) => {
          let snippetResult = results.findWhere({ text: item });
          if (snippetResult) {
            //set the value of the textbox
            input.val(item);
            this.trigger("search", snippetResult); //trigger event on view, passing the matched model
            return item;
          }
        },
      });
    },
  });

  return SnippetSearchView;
});
